<template>
  <div v-if="cosmoMode" class="gfooter">
    <p class="gfooter__copyright">© COSMO ENERGY HOLDINGS Co., Ltd. All Rights Reserved.</p>
  </div>
  <div v-else class="gfooter">
    <div class="gfooter__content">
      <div class="gfooter__nav_stack">
        <nav class="gfooter__sub-nav">
          <ul class="gfooter__sub-nav__content">
            <li class="gfooter__sub-nav__item"><a class="gfooter__sub-nav__item__content" href="https://www.cosmo-energy.co.jp/ja/privacy/policy.html">プライバシーポリシー</a></li>
            <li class="gfooter__sub-nav__item"><a class="gfooter__sub-nav__item__content" href="https://www.cosmo-energy.co.jp/ja/privacy.html">個人情報保護方針</a></li>
            <li class="gfooter__sub-nav__item"><a class="gfooter__sub-nav__item__content" href="https://www.cosmo-energy.co.jp/ja/privacy/smpolicy.html">ソーシャルメディアポリシー</a></li>
            <li class="gfooter__sub-nav__item"><a class="gfooter__sub-nav__item__content" href="https://www.cosmo-energy.co.jp/ja/privacy/about.html">サイト利用条件</a></li>
            <li v-if="hasCookieConsentBtn" class="gfooter__sub-nav__item"><a class="gfooter__sub-nav__item__content" href="#" @click.prevent="openCookieSettings">Cookie設定</a></li>
            <li class="gfooter__sub-nav__item"><a class="gfooter__sub-nav__item__content" href="https://www.cosmo-energy.co.jp/ja/sitemap.html">サイトマップ</a></li>
          </ul>
        </nav>
      </div>

      <div class="gfooter__trailer">
        <p class="gfooter__logo-corp"><a class="gfooter__logo-corp__content" href="https://www.cosmo-energy.co.jp/ja/top.html">
          <img src="https://storage.googleapis.com/storelocator-v3-static/images/cosmo/d35ad3a8-57b8-486f-b6e3-0afaab74e269.png" alt=""></a></p>
        <p class="gfooter__copyright">© COSMO ENERGY HOLDINGS Co., Ltd. All Rights Reserved.</p>
      </div>
    </div>
  </div>

  <template v-if="visibleSkipButton">
    <div class="footer-button-margin"></div>
    <div class="footer-skip-button-wrapper">
      <a
        class="app-button action uk-button uk-button-small ss-skip-button icon-inline with-icon" 
        @click="onSkipSelectSS"
        v-wave
      >
        <span class="text-modifier">あとで選択する</span>
      </a>
    </div>
  </template>

</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import functions from '../utils/functions.ts'


/**
 * 外部サイトから遷移してきた際の外部サイトのID
 * こちらの値が入っていた場合は、ヘッダ、フッタのリンクを表示させない
 */
const cosmoMode = storelocator.url_params?.cosmo_mode || ''

/**
 * アプリ向け、サービスステーション選択をスキップするボタンの表示
 * iframeとskip=1のパラメータがあれば表示
 */
const visibleSkipButton:boolean = storelocator.url_params?.iframe !== undefined && storelocator.url_params?.skip == '1'

/**
 * セルフサービスステーション選択をスキップするハンドラー
 * @returns {void}
 */
const onSkipSelectSS = () => {
  functions.handleSkipSelectSS()
}

/**
 * STRIGHTが div[data-id="cookie_consent_cookie_btn"] 内にbuttonを注入した場合のみ
 * Cookie設定リンクを表示する。動的注入に対応するためMutationObserverで監視する。
 */
const COOKIE_BTN_SELECTOR = 'div[data-id="cookie_consent_cookie_btn"] button'
const hasCookieConsentBtn = ref(!!document.querySelector(COOKIE_BTN_SELECTOR))
let observer: MutationObserver | null = null

onMounted(() => {
  if (hasCookieConsentBtn.value) return
  observer = new MutationObserver(() => {
    if (document.querySelector(COOKIE_BTN_SELECTOR)) {
      hasCookieConsentBtn.value = true
      observer?.disconnect()
      observer = null
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })
})

onUnmounted(() => {
  observer?.disconnect()
})

const openCookieSettings = () => {
  const btn = document.querySelector<HTMLButtonElement>(COOKIE_BTN_SELECTOR)
  btn?.click()
}
</script>

<style lang="scss" scoped>
// fixedボタン用のページ下部マージン
.footer-button-margin {
  height: 54px;
}
.footer-skip-button-wrapper {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 8px 16px;
  background-color: #fff;
  border-top: 1px solid #efefef;
  align-items: center;

  .ss-skip-button {
    margin: 0;
    min-width: 100%;
    padding: 4px 8px;
    border-radius: 16px;
    background-color: #eee;
    color: var(--theme-text);
    &:active {
      color: #333;
      background-color: #eee;
    }
  }
}
.iframe .footer-skip-button-wrapper {
  display: flex;
}

/* Footer */

.gfooter {
  border-top: 1px solid #cfd8dc;
  position: relative;
  background-color: #fff
}

.gfooter * {
  box-sizing: border-box
}

.gfooter ul {
  margin: 0;
  padding: 0;
  list-style: none
}

.gfooter a {
  text-decoration: none
}

.gfooter .gfooter__sub-nav {
  margin-top: 32px;
  padding: 0 69px;
  font-size: 12px
}

.gfooter .gfooter__sub-nav .gfooter__sub-nav__content {
  -webkit-column-gap: 28px;
  -moz-column-gap: 28px;
  column-gap: 28px;
  display: flex
}

.gfooter .gfooter__sub-nav a.gfooter__sub-nav__item__content:hover {
  color: #2c31a6;
  text-decoration: underline
}

.gfooter .gfooter__sub-nav span.gfooter__sub-nav__item__content {
  opacity: .4
}

.gfooter .gfooter__sub-nav .gfooter__sub-nav__item__content {
  color: #3c3c40;
  line-height: 1.5
}

@media print, screen and (max-width: 460px) {
  .gfooter .gfooter__sub-nav .gfooter__sub-nav__content {
      max-width: 340px;
  }
}

@media print,
screen and (max-width: 1254px) {
  .gfooter .gfooter__sub-nav {
    margin-top: 0;
    padding: 32px 16px 0
  }

  .gfooter .gfooter__sub-nav .gfooter__sub-nav__content {
    -webkit-column-gap: 24px;
    -moz-column-gap: 24px;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    margin: auto
  }
}

.gfooter .gfooter__trailer {
  border-top: 1px solid #cfd8dc;
  align-items: center;
  margin-top: 24px;
  padding: 24px 69px;
  display: flex
}

@media print,
screen and (max-width: 1254px) {
  .gfooter .gfooter__trailer {
    flex-direction: column;
    row-gap: 24px;
    margin-top: 32px
  }
}

.gfooter .gfooter__logo-corp {
  margin: 0
}

.gfooter .gfooter__logo-corp .gfooter__logo-corp__content {
  width: 100px;
  display: block
}

.gfooter .gfooter__logo-corp .gfooter__logo-corp__content>img {
  width: 100%;
  height: auto;
  display: block
}

.gfooter .gfooter__copyright {
  color: #7f7f7f;
  margin: 0 0 0 auto;
  font-size: 10px
}
@media print,
screen and (max-width: 1254px) {
  .gfooter .gfooter__copyright {
    margin: 0
  }
}
</style>
